import { Box, ScaleFade } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

import { usePlayerState } from '@/components/ui/features/lecture/LecturePlayer/LecturePlayer.hooks';

const peerHoverStyle = {
  opacity: '0',
  _hover: { opacity: 1 },
  _peerHover: { opacity: 1 },
  transition: 'opacity 0.2s',
};

export const LecturePlayerLanguageSelection: FC<{ children: ReactNode }> = ({ children }) => {
  const { activeTrack } = usePlayerState();

  return (
    <Box {...peerHoverStyle} position="absolute" top="10px" right="10px" zIndex="1">
      <ScaleFade initialScale={0.01} in={Boolean(!activeTrack)} transition={{ exit: { duration: 0.2 } }}>
        {children}
      </ScaleFade>
    </Box>
  );
};
